// PENDING TODO improve locale on base file instead of here since its a general type
// type TypeLocale = 'en-EU' | 'es-ES' | 'es-CT' | 'es-CN' | 'es-MD' | 'en-GB' | 'fr-FR' | 'de-DE'
// type TypeLocaleCountry = 'es-ES' | 'en-GB' | 'fr-FR' | 'de-DE'

import { LANGUAGES } from './constants'

// export function getLocaleCountry(locale: TypeLocale): TypeLocaleCountry {
export function getLocaleCountry(locale:string) {
  switch (locale) {
    case 'es-CN':
    case 'es-CT':
    case 'es-MD':
      return 'es-ES'
    case 'en-EU':
      return 'en-GB'
    default:
      return locale
  }
}

export const getStoreByLocale = {
  'en-EU': 'Europe',
  'es-ES': 'España',
  'es-CN': 'Canarias',
  'es-CT': 'España',
  'es-MD': 'España',
  // 'es-CT': 'Cataluña',
  // 'es-MD': 'Madrid',
  'fr-FR': 'France',
  'en-GB': 'United Kingdom',
  'de-DE': 'Deutschland',
  'pt-PT': 'Portugal',
}

export const getStoreUrlByLocale = (locale, PRO) => {
  const url = {
    'en-EU': 'mammafiore.eu',
    'es-ES': 'mammafiore.es',
    'es-CN': 'canarias.mammafiore.es',
    'es-CT': 'mammafiore.es',
    'es-MD': 'mammafiore.es',
    // 'es-CT': 'cat.mammafiore.es',
    // 'es-MD': 'madrid.mammafiore.es',
    'fr-FR': 'mammafiore.fr',
    'en-GB': 'mammafiore.co.uk',
    'de-DE': 'mammafiore.de',
    'pt-PT': 'mammafiore.pt',
  }

  if(!url[locale]) return undefined
  return (!PRO ? 'staging.' : '') + url[locale]
}


type TypeValidLanguage = typeof LANGUAGES[number]
export function getLang(str: string): TypeValidLanguage {
  if (typeof str !== 'string') throw new Error('getLang parameter must be typeof "string"')

  const lang = str.substring(0, 2) as TypeValidLanguage // Fix the substring bug

  if (LANGUAGES.includes(lang)) return lang

  console.warn(`Language "${lang}" not found in LANGUAGES constant. Falling back to "${LANGUAGES[0]}"`)
  return LANGUAGES[0] // 'es'
}

export function getRegion(str:string) {
  if (typeof str !== 'string') throw new Error('getRegion parameter must be typeof "string"')
  return str.split('-')[1]
}

export const hasPrivateStore = {
  mmf: {
    'en-EU': false,
    'es-ES': false,
    'es-CT': false,
    'es-MD': false,
    'es-CN': false,
    'fr-FR': false,
    'en-GB': false,
    'pt-PT': false,
    'de-DE': false,
  },
  hm: {
    'es-ES': false,
    'fr-FR': false,
    'en-GB': false,
    'pt-PT': false,
    'de-DE': false,
  }
}


export const PRIVATE_PATHS = [
  '/welcome',
  '/shop',
  '/account',
  '/checkout',
  '/cart',
]


// export const redirectToPrivatePathnameVersion = (pathname: string, searchParams: URLSearchParams) => {

// }
